export const email = 'contact@glassnode.com';
export const mailto = `mailto:${email}`;
export const phone = '+41 79 133 65 34';

export const medium = 'glassnode';
export const mediumUrl = `https://medium.com/@${medium}`;

export const twitter = 'glassnode';
export const twitterUrl = `https://twitter.com/${twitter}`;

export const telegram = 'glassnode';
export const telegramUrl = `https://t.me/${telegram}`;

export const loading = 'Loading...';

export const error = 'Oops, there was an error, please refresh.';
export const errorShort = 'Oops, there was an error.';
export const errorRateLimit = 'Too many requests. Please wait a moment before refreshing.';
export const errorRateLimitUpgrade = 'Too many requests. Upgrade your plan or please wait a moment before refreshing.';

export const cancelationInfo = 'On cancelation, subscription stays active until end of billing cycle';
